<template>
  <div>
      <div class="group-rounded-box row-py-clear">
        <div class="row">
          <div class="col-12">
            <h3 class="mt-0">Credit Limit</h3>
            <p class="mb-4">Manage your customers' credit limit below. Customers will not be able to place orders whose value exceed this credit limit.</p>
          </div>
        </div>
        <div class="row">
            <div class="col-md-2 col-sm-12">
              Credit Limit GBP
            </div>
            <div class="col-4">
              <span class="d-block">
                  <cleave :class="{ 'border-t_red': creditLimitError }" v-model="credit" class="text-right" :options="numeralPositive" placeholder="Enter credit limit"></cleave>
              </span>
                <span v-if="creditLimitError" class="error-message d-block">
                    {{creditLimitError}}
                </span>
            </div>
        </div>
        <div class="row mt-5">
          <div class="col-12">
            <h3 class="mt-0">Payment Terms</h3>
            <p class="mb-4">Input payment terms in days below. This payment term will apply to all orders placed through the platform.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2 col-sm-12">
              Payment Terms (Days)
          </div>
          <div class="col-4">
              <span>
                <cleave :class="{ 'border-t_red': creditDaysError }" v-model="days" class="text-right d-block" :options="numeralPositive" placeholder="Enter payment terms"></cleave>
                </span>
                <!-- Bind error-message-popup class to display the error message -->
                <span v-if="creditDaysError" class="error-message d-block">
                    {{creditDaysError}}
                </span>
          </div>
        </div>
        <div class="modal-footer justify-content-center mt-5">
          <el-button class="btn btn-neutral" size="small" @click="emitClose">
            Close
          </el-button>
          <el-button class="btn btn-neutral" size="small" :disabled="true">
            Back
          </el-button>
          <el-button class="btn btn-neutral" size="small" @click="emitNext" :disabled="tabIndex >= tabsLength">
            Next
          </el-button>
          <el-button class="btn btn-confirm" size="small" @click.prevent="save" :disabled="!unsavedChangesFound || (creditDaysError || creditLimitError)" :loading="saveBtnLoading">
            Save
          </el-button>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import{ editCustomerRelationship } from '@/api/relationships.js';

const MAX_CREDIT_DAYS = 100;
const MIN_CREDIT_LIMIT = 1000;
const MAX_CREDIT_LIMIT = 100000000;

const CREDIT_DAYS_ERROR = 'Please enter a valid payment term';
const CREDIT_LIMIT_ERROR = 'Please enter a valid credit limit';

export default {
  data(){
    return {
      saveBtnLoading: false,
      credit: 0,
      days: 0,
      initialState: null
    }
  },
  created(){
    this.credit = this.relationshipProp.credit.limit;
    this.days = this.relationshipProp.credit.days;
    this.initialState = {
      credit: this.credit,
      days: this.days
    };
  },
  props: {
    relationshipProp: {
      type: Object,
      default: () => {},
      required: true
    },
    tabsLength: {
      type: Number,
      default: 0,
      required: true
    },
    tabIndex: {
      type: Number,
      default: 0,
      required: true
    },
  },
  computed:{
    ...mapGetters('inputCheckers',['numeralPositive']),
    creditDaysError:{
      get: function(){
        const daysNumber = Number(this.days);
        if(this.days === ''|| this.days == null || daysNumber > MAX_CREDIT_DAYS || !Number.isInteger(daysNumber))
          return CREDIT_DAYS_ERROR;
        return false;
      }
    },
    creditLimitError:{
      get: function(){
        const creditNumber = Number(this.credit);
        if(this.credit == '' || this.credit == null || creditNumber < MIN_CREDIT_LIMIT || creditNumber > MAX_CREDIT_LIMIT)
          return CREDIT_LIMIT_ERROR;
        return false;
      }
    },
    unsavedChangesFound: function(){
      const status = Number(this.initialState && this.initialState.credit) !== Number(this.credit)
        || Number(this.initialState && this.initialState.days) !== Number(this.days);
      this.$emit('emit-tracked-changes', status);
      return status;
    }
  },
  watch: {
    unsavedChangesFound(){}
  },
  methods:{
    emitNext(){
      this.$emit('emit-next', this.tabIndex)
    },
    emitClose(){
      this.$emit('emit-close', this.tabIndex);
    },
    save: async function() {
      const newCreditDays = Number(this.days)
      const newCreditLimit = Number(this.credit)

        const payload = {
          relationshipId: this.relationshipProp.relationshipId,
          buyerAccountId: this.relationshipProp.id,
          creditDays: newCreditDays,
          creditLimit: newCreditLimit
        }
        this.saveBtnLoading = true;
        await editCustomerRelationship(payload);
        this.saveBtnLoading = false;
        this.$emit("reloadRelationshipProp");
      },
  }
}
</script>